import { apiClient } from '../../api_actions';
import { Modal, Select, Space, Input } from 'antd';
import React, { useState, useEffect } from 'react';

function LogoCell({ id }) {
  if (!id) return '-';
  const token = localStorage.getItem('token');
  const url = process.env.REACT_APP_DOWNLOAD_URL + `/assets/logo?logo_id=${id}&token=${token}`
  console.log(url)
  return (
    <img
      src={url}
      alt="Customer logo"
      style={{
        width: 60,
        height: 'auto',
        borderRadius: 4,
        border: '1px solid #d9d9d9'
      }}
    />
  );
}

export default LogoCell